import Wrapper from "../../../layout/Wrapper";
import LifeContractServiceComponent from "../../../screens/contractControll/lifeContract";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Service",
	description: "",
};

export default function AgentService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<LifeContractServiceComponent />
		</Wrapper>
	);
}